import React, {useState} from 'react';
import {Navbar, Nav, Button, Offcanvas} from 'react-bootstrap';
import { ContainerOutlined, UserOutlined, SettingOutlined, DashboardOutlined } from '@ant-design/icons';
import {isSuperAdmin} from "../../../../GlobalServices";

interface Props {
    show: boolean;
    handleClose: () => void;
}

const Sidebar = ({show, handleClose}: Props) => {
    // const [show, setShow] = useState(false);
    //
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    const czyAktywne = (link: string): string => {
        if(window.location.pathname.indexOf(link) > -1){
            return 'linkAktywny';
        } else {
            return '';
        }
    }

    return (
        <>
            {/* Przycisk widoczny tylko na mniejszych ekranach */}
            {/*<Button variant="primary" onClick={handleShow} className="d-lg-none">*/}
            {/*    Menu*/}
            {/*</Button>*/}

            {/* Sidebar widoczny na dużych ekranach */}
            <Navbar expand="lg" className="flex-column vh-100 d-none d-lg-flex" style={{width: '250px'}}>
                <Navbar.Brand href="/admin">Sygnalista TOP</Navbar.Brand>
                <Nav className="flex-column">
                    <Nav.Link href="/admin" className={(window.location.pathname.indexOf('n/') > -1) ? '' : czyAktywne('/admin')}><DashboardOutlined /> Panel główny</Nav.Link>
                    <Nav.Link href="/admin/zgloszenia" className={czyAktywne('/admin/zgloszenia')}><ContainerOutlined /> Zgłoszenia</Nav.Link>
                    <Nav.Link href="/admin/uzytkownicy" className={czyAktywne('/admin/uzytkownicy')} hidden={!isSuperAdmin()}><UserOutlined /> Użytkownicy</Nav.Link>
                    <Nav.Link href="/admin/ustawienia" className={czyAktywne('/admin/ustawienia')}><SettingOutlined /> Ustawienia</Nav.Link>
                </Nav>
            </Navbar>

            {/* Offcanvas (menu wysuwane) na mniejszych ekranach */}
            <Offcanvas show={show} onHide={handleClose} className="d-lg-none">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Sygnalista TOP - Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        <Nav.Link href="/admin" onClick={handleClose}><DashboardOutlined /> Panel główny</Nav.Link>
                        <Nav.Link href="/admin/zgloszenia" onClick={handleClose}><ContainerOutlined /> Zgłoszenia</Nav.Link>
                        <Nav.Link href="/admin/uzytkownicy" onClick={handleClose} hidden={!isSuperAdmin()}><UserOutlined /> Użytkownicy</Nav.Link>
                        <Nav.Link href="/admin/ustawienia" onClick={handleClose}><SettingOutlined /> Ustawienia</Nav.Link>
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default Sidebar;
